(function () {
  'use strict';

  var FAVORITES_KEY = 'zs-favoritos';

  function readFavorites() {
    try {
      var parsed = JSON.parse(window.localStorage.getItem(FAVORITES_KEY) || '[]');
      return Array.isArray(parsed) ? parsed.filter(Boolean).slice(0, 50) : [];
    } catch (error) {
      return [];
    }
  }

  function writeFavorites(handles) {
    try { window.localStorage.setItem(FAVORITES_KEY, JSON.stringify(handles)); } catch (error) {}
    document.dispatchEvent(new CustomEvent('zs:favorites:changed', { detail: { handles: handles } }));
  }

  function syncFavoriteButtons(root) {
    var favorites = readFavorites();
    (root || document).querySelectorAll('[data-zs-card-favorite]').forEach(function (button) {
      var active = favorites.indexOf(button.dataset.productHandle) !== -1;
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
      var productName = button.closest('[data-zs-product-card]')?.querySelector('.zs-product-card__title')?.textContent.trim() || 'este producto';
      button.setAttribute('aria-label', (active ? 'Quitar ' : 'Agregar ') + productName + (active ? ' de favoritos' : ' a favoritos'));
    });
  }

  function formatMoney(cents) {
    var currency = window.Shopify?.currency?.active || 'ARS';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'es-AR', {
        style: 'currency',
        currency: currency,
        maximumFractionDigits: 0
      }).format(Number(cents || 0) / 100);
    } catch (error) {
      return '$' + (Number(cents || 0) / 100).toFixed(2);
    }
  }

  function initQuickView() {
    var modal = document.querySelector('[data-zs-quick-view]');
    if (!modal || modal.dataset.zsReady === 'true') return;
    modal.dataset.zsReady = 'true';

    var dialog = modal.querySelector('.zs-quick-view__dialog');
    var loading = modal.querySelector('[data-zs-quick-loading]');
    var media = modal.querySelector('[data-zs-quick-media]');
    var image = modal.querySelector('[data-zs-quick-image]');
    var info = modal.querySelector('[data-zs-quick-info]');
    var title = modal.querySelector('[data-zs-quick-title]');
    var price = modal.querySelector('[data-zs-quick-price]');
    var compare = modal.querySelector('[data-zs-quick-compare]');
    var options = modal.querySelector('[data-zs-quick-options]');
    var stock = modal.querySelector('[data-zs-quick-stock]');
    var quantity = modal.querySelector('[data-zs-quick-quantity]');
    var submit = modal.querySelector('[data-zs-quick-submit]');
    var error = modal.querySelector('[data-zs-quick-error]');
    var details = modal.querySelector('[data-zs-quick-details]');
    var product = null;
    var currentVariant = null;
    var opener = null;

    function variantOptions(variant) {
      if (Array.isArray(variant.options)) return variant.options;
      return [variant.option1, variant.option2, variant.option3].filter(function (value) { return value != null; });
    }

    function optionNames(data) {
      return (data.options || []).map(function (option, index) {
        if (typeof option === 'string') return option;
        return option.name || ('Opción ' + (index + 1));
      });
    }

    function selectedValues() {
      return Array.prototype.map.call(options.querySelectorAll('select'), function (select) { return select.value; });
    }

    function setProductImage(variant) {
      var source = variant?.featured_image?.src || variant?.featured_image || product?.featured_image || product?.images?.[0] || '';
      if (typeof source === 'object') source = source.src || '';
      if (!source) {
        media.hidden = true;
        return;
      }
      image.src = source;
      image.alt = product.title || '';
      media.hidden = false;
    }

    function updateVariant() {
      if (!product) return;
      var values = selectedValues();
      currentVariant = product.variants.find(function (variant) {
        var candidate = variantOptions(variant);
        return candidate.length === values.length && candidate.every(function (value, index) { return value === values[index]; });
      }) || product.variants.find(function (variant) { return variant.available; }) || product.variants[0];

      if (!currentVariant) return;
      price.textContent = formatMoney(currentVariant.price);
      if (currentVariant.compare_at_price && currentVariant.compare_at_price > currentVariant.price) {
        compare.textContent = formatMoney(currentVariant.compare_at_price);
        compare.hidden = false;
      } else {
        compare.hidden = true;
      }
      stock.textContent = currentVariant.available ? 'Disponible para agregar al carrito' : 'Variante sin stock';
      stock.classList.toggle('is-sold-out', !currentVariant.available);
      submit.disabled = !currentVariant.available;
      submit.textContent = currentVariant.available ? 'Agregar al carrito' : 'Agotado';
      setProductImage(currentVariant);
    }

    function buildOptions(data, initialVariant) {
      options.replaceChildren();
      var names = optionNames(data);
      names.forEach(function (name, optionIndex) {
        var field = document.createElement('div');
        field.className = 'zs-quick-view__field';
        var label = document.createElement('label');
        var select = document.createElement('select');
        var id = 'ZsQuickOption-' + optionIndex;
        label.htmlFor = id;
        label.textContent = name;
        select.id = id;
        select.dataset.optionIndex = optionIndex;

        var values = [];
        data.variants.forEach(function (variant) {
          var value = variantOptions(variant)[optionIndex];
          if (value != null && values.indexOf(value) === -1) values.push(value);
        });
        values.forEach(function (value) {
          var option = document.createElement('option');
          option.value = value;
          option.textContent = value;
          if (variantOptions(initialVariant)[optionIndex] === value) option.selected = true;
          select.appendChild(option);
        });
        select.addEventListener('change', updateVariant);
        field.append(label, select);
        options.appendChild(field);
      });
    }

    function resetView() {
      loading.hidden = false;
      info.hidden = true;
      media.hidden = true;
      error.hidden = true;
      error.textContent = '';
      quantity.value = 1;
      product = null;
      currentVariant = null;
    }

    function openModal(button) {
      opener = button;
      resetView();
      modal.hidden = false;
      modal.setAttribute('aria-hidden', 'false');
      document.body.classList.add('zs-quick-view-open');
      dialog.focus();
      if (typeof window.trapFocus === 'function') window.trapFocus(dialog);

      var url = button.dataset.productUrl || ('/products/' + button.dataset.productHandle);
      var productUrl = new URL(url, window.location.origin);
      var productJsonUrl = productUrl.pathname.replace(/\/$/, '') + '.js';
      fetch(productJsonUrl, { headers: { Accept: 'application/json' } })
        .then(function (response) {
          if (!response.ok) throw new Error('No pudimos cargar el producto.');
          return response.json();
        })
        .then(function (data) {
          product = data;
          currentVariant = data.variants.find(function (variant) { return variant.available; }) || data.variants[0];
          title.textContent = data.title;
          details.href = data.url || url;
          buildOptions(data, currentVariant);
          updateVariant();
          loading.hidden = true;
          info.hidden = false;
        })
        .catch(function (requestError) {
          loading.hidden = true;
          info.hidden = false;
          title.textContent = 'Producto no disponible';
          error.textContent = requestError.message;
          error.hidden = false;
          submit.disabled = true;
        });
    }

    function closeModal() {
      modal.hidden = true;
      modal.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('zs-quick-view-open');
      if (typeof window.removeTrapFocus === 'function') window.removeTrapFocus(opener);
      else if (opener) opener.focus();
    }

    function addToCart() {
      if (!currentVariant?.available || submit.disabled) return;
      error.hidden = true;
      submit.disabled = true;
      submit.textContent = 'Agregando…';
      var formData = new FormData();
      formData.append('id', currentVariant.id);
      formData.append('quantity', Math.max(1, Number(quantity.value) || 1));
      var cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      if (cart?.getSectionsToRender) {
        formData.append('sections', cart.getSectionsToRender().map(function (section) { return section.id; }));
        formData.append('sections_url', window.location.pathname);
        if (cart.setActiveElement) cart.setActiveElement(opener);
      }

      fetch(window.routes?.cart_add_url || '/cart/add.js', {
        method: 'POST',
        headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' },
        body: formData
      })
        .then(function (response) {
          var contentType = response.headers.get('content-type') || '';
          if (contentType.indexOf('application/json') !== -1) return response.json();
          if (!response.ok) throw new Error('No se pudo agregar al carrito.');
          return { zsHtmlSuccess: true };
        })
        .then(function (response) {
          if (response.status) throw new Error(response.description || response.message || 'No se pudo agregar al carrito.');
          closeModal();
          if (response.zsHtmlSuccess) {
            var cartUrl = window.routes?.cart_url || '/cart';
            var destination = new URL(cartUrl, window.location.origin);
            if (destination.pathname === window.location.pathname) window.location.reload();
            else window.location.href = destination.href;
          }
          else if (cart?.renderContents) cart.renderContents(response);
          else window.location.href = window.routes?.cart_url || '/cart';
        })
        .catch(function (cartError) {
          error.textContent = cartError.message;
          error.hidden = false;
          submit.disabled = false;
          submit.textContent = 'Agregar al carrito';
        });
    }

    document.addEventListener('click', function (event) {
      var favoriteButton = event.target.closest('[data-zs-card-favorite]');
      if (favoriteButton) {
        var favorites = readFavorites();
        var handle = favoriteButton.dataset.productHandle;
        var index = favorites.indexOf(handle);
        if (index === -1) favorites.push(handle);
        else favorites.splice(index, 1);
        writeFavorites(favorites);
        syncFavoriteButtons(document);
        return;
      }

      var quickButton = event.target.closest('[data-zs-quick-open]');
      if (quickButton) {
        openModal(quickButton);
        return;
      }

      if (event.target.closest('[data-zs-quick-close]')) closeModal();
    });

    modal.querySelector('[data-zs-quick-minus]').addEventListener('click', function () {
      quantity.value = Math.max(1, (Number(quantity.value) || 1) - 1);
    });
    modal.querySelector('[data-zs-quick-plus]').addEventListener('click', function () {
      quantity.value = Math.max(1, (Number(quantity.value) || 1) + 1);
    });
    submit.addEventListener('click', addToCart);
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !modal.hidden) closeModal();
    });
  }

  function init(root) {
    syncFavoriteButtons(root || document);
    initQuickView();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);

  document.addEventListener('zs:favorites:changed', function () { syncFavoriteButtons(document); });
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
}());
